import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import reportWebVitals from "./reportWebVitals";
import App from "./App";
import "./index.css";
import AuthProvider from "./context/AuthProvider";
import { CookiesProvider } from "react-cookie";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  // <React.StrictMode>
    <CookiesProvider>
      <AuthProvider>
        <Router>
          <App />
        </Router>
      </AuthProvider>
    </CookiesProvider>
  // </React.StrictMode>
);

reportWebVitals();
